var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-monitor"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "monitor",
    clipPath: "url(#clip-monitor)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "monitor-2",
    "data-name": "monitor",
    transform: "translate(2.877 3.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8494",
    "data-name": "Group 8494",
    transform: "translate(-1.876 -1.612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18658",
    "data-name": "Path 18658",
    d: "M14.125,36H1.875A1.877,1.877,0,0,0,0,37.875v7.5A1.877,1.877,0,0,0,1.875,47.25h5.5V48.5H4.125v1.25h7.75V48.5H8.625V47.25h5.5A1.877,1.877,0,0,0,16,45.375v-7.5A1.877,1.877,0,0,0,14.125,36Zm.625,9.375a.626.626,0,0,1-.625.625H1.875a.626.626,0,0,1-.625-.625v-7.5a.626.626,0,0,1,.625-.625h12.25a.626.626,0,0,1,.625.625Z",
    transform: "translate(0 -36)",
    fill: "#2f394e"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.b1f7c2bb.svg";
export { ForwardRef as ReactComponent };